/**
 * Message Component
 *
 * Status: [IMPLEMENTED]
 * Task: T2.1 - Chat UI Component
 *
 * Renders a single message bubble.
 * Assistant messages render markdown for better formatting.
 * Shows resume email form when bot asks for email.
 */

import React from 'react';
import ReactMarkdown from 'react-markdown';
import ResumeEmailForm from './ResumeEmailForm';

// Phrase that triggers the resume email form
const RESUME_TRIGGER_PHRASE = "[RESUME_REQUEST]";

const Message = ({ role, content, timestamp }) => {
  const isUser = role === 'user';

  // Check if this message should show the resume email form
  const showResumeForm = !isUser && content.includes(RESUME_TRIGGER_PHRASE);

  // Remove the trigger phrase from displayed content
  const displayContent = content.replace(RESUME_TRIGGER_PHRASE, '').trim();

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`max-w-[80%] rounded-lg px-4 py-2 ${
          isUser
            ? 'bg-sky-600 text-white rounded-br-none'
            : 'bg-gray-100 dark:bg-slate-700 text-gray-800 dark:text-slate-100 rounded-bl-none'
        }`}
      >
        {isUser ? (
          <p className="text-sm whitespace-pre-wrap">{displayContent}</p>
        ) : (
          <div className="text-sm markdown-content">
            <ReactMarkdown
              components={{
                h1: ({children}) => <h1 className="text-lg font-semibold mt-2 mb-1">{children}</h1>,
                h2: ({children}) => <h2 className="text-base font-semibold mt-2 mb-1">{children}</h2>,
                h3: ({children}) => <h3 className="text-sm font-semibold mt-2 mb-1">{children}</h3>,
                p: ({children}) => <p className="my-1">{children}</p>,
                ul: ({children}) => <ul className="list-disc list-inside my-1">{children}</ul>,
                ol: ({children}) => <ol className="list-decimal list-inside my-1">{children}</ol>,
                li: ({children}) => <li className="my-0.5">{children}</li>,
                code: ({children}) => <code className="bg-gray-200 dark:bg-slate-600 px-1 rounded text-gray-800 dark:text-slate-200 text-xs">{children}</code>,
                strong: ({children}) => <strong className="font-semibold">{children}</strong>,
              }}
            >
              {displayContent}
            </ReactMarkdown>
          </div>
        )}
        {timestamp && (
          <p
            className={`text-xs mt-1 ${
              isUser ? 'text-sky-200' : 'text-gray-400 dark:text-slate-400'
            }`}
          >
            {new Date(timestamp).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </p>
        )}

        {/* Resume email form (shown when bot asks for email) */}
        {showResumeForm && <ResumeEmailForm />}
      </div>
    </div>
  );
};

export default Message;
